// import React from 'react';
// import CountDown from 'react-native-countdown-component'; 

// export default ({timer, submitTest, style, inSeconds, textStyles, separatorStyle, digitStyles, size, hours, onFinish}) => {
//     const _timer = timer ? timer : 10
//     const milliseconds = 1000 * 60 * timer;
//     const minutes = timer * 60;
//     const seconds = 1000 * timer;
//     const _onFinish = submitTest || onFinish 
//     return (
//       <CountDown
//         size={10}
//         until={inSeconds ? timer : minutes}
//         onFinish={_onFinish}
//         digitStyle={{backgroundColor: 'transparent', borderWidth: 0, borderColor: '#1CC625', padding: 0, margin: 0, height: size ? size*1.5 : 15, width: size ? size*1.3 : 13, ...digitStyles}}
//         digitTxtStyle={{color: '#000', ...textStyles}}
//         // timeLabelStyle={{color: 'red', fontWeight: 'bold'}}
//         separatorStyle={{color: '#000', margin: 0, padding: 0, ...separatorStyle}}
//         timeToShow={hours ? ['H', 'M', 'S']: ['M', 'S']}
//         timeLabels={{m: null, s: null}}
//         showSeparator
//         size={size || 10}
//       />
//     )
// }
import React from "react";
import { Typography } from "@material-ui/core";
import Countdown, { formatTimeDelta, CountdownRenderProps } from 'react-countdown-now';

// const convertTimer = (time) => {
//   // let hours = Math.floor(num / 60);  
  
//   return  console.log(parseInt(time  * 60));
   
// }
class ExamTimer extends React.Component{
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.timer != this.props.timer;
} 
examTimerComplete = () => {
    this.props.onSubmit();
}

renderer = ({ hours, minutes, seconds,}) => {
 
const _hours = hours > 9 ? hours : '0' + hours;
const _minutes = minutes > 9 ? minutes :  '0' + minutes;
const _seconds = seconds > 9 ? seconds : '0' + seconds;
  // Render a countdown
  return (
    <span style={{fontWeight: 'bold', fontSize: 15, color: this.props.textStyles ? '#fff' : '#000'}}>
         {
             this.props.hours ?

            ` ${_hours} : ${_minutes} : ${_seconds}`
             :
             `${_minutes} : ${_seconds}`
         }
    </span>
  );

}

  render(){
    // console.log(this.props.timer);
    return (
      <div 
    //   className={`${this.props.top} ${this.props.left}`} style={{ display: "flex", alignItems: "center", }}
      >
      
         
          <Countdown 
          date={this.props.testDetails ? Date.now() + (this.props.timer * 60 * 1000)/60  : Date.now() + this.props.timer * 60 * 1000}
          // date={this.startTimer()}
          //  formatTimeDelta={this.renderer(Date.now() + 4000000, [2])}
          onComplete={this.examTimerComplete}
          renderer={this.renderer}
          //zeroPadDays={null}
          precision={0}
          />
        </div>
    //   </div>
    );
  }
 
  
};
export default ExamTimer

 